export enum DEVICE_TYPE {
  DESKTOP = 'WEBSITE',
  MOBILE = 'MSITE',
}

let deviceType: DEVICE_TYPE = DEVICE_TYPE.MOBILE;

export const setDeviceType = (newDeviceType: DEVICE_TYPE) => {
  deviceType = newDeviceType;
};

export const getDeviceType = () => deviceType;

export const getDomain = () => 'NYKAA_FASHION';
